import { render } from "./RiskAvoidanceGuide.vue?vue&type=template&id=e27c17c6&scoped=true"
import script from "./RiskAvoidanceGuide.vue?vue&type=script&lang=js"
export * from "./RiskAvoidanceGuide.vue?vue&type=script&lang=js"

import "./RiskAvoidanceGuide.vue?vue&type=style&index=0&id=e27c17c6&scoped=true&lang=scss"

import exportComponent from "/data/jenkins/workspace/yh-node-yh-mallrobot-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e27c17c6"]])

export default __exports__